






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { copyDDLs, getSubDDL } from '@/configs/functions'
import { DDLItem, DefDDLItem } from '@/api/common/select'

import { namespace } from 'vuex-class'
import { enFirstType } from '@/configs/enums'
const DataSourceModule = namespace('dataSource')

@Component({
  components: {}
})
export default class AreaSelector extends Vue {
  public name = 'AreaSelector'

  //点击查询事件
  @Prop({ default: 0 })
  public cityId!: number
  @Prop({ default: 0 })
  public countyId!: number
  @Prop({ default: 0 })
  public townshipId!: number
  //是否需要首选项, 默认不需要首选项
  @Prop({ default: enFirstType.All })
  public firstType!: enFirstType

  /**显示级别，city/county/township*/
  @Prop({ default: 'township' })
  public areaLvl!: string

  public defItem: DDLItem = DefDDLItem(this.firstType)
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]
  public townshipList: DDLItem[] = [this.defItem]

  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  public created() {
    var cityCounty = copyDDLs(this.cityCounty, this.firstType)
    if (cityCounty) {
      this.cityList = cityCounty
    }
  }
  public mounted() {
    this.$nextTick(() => {
      if (this.cityId = 0 && this.cityList.length == 2) {
        this.cityId = this.cityList[1].Key
      }
      if (this.cityId > 0) {
        this.loadCounty(0)
      }
      if (this.countyId > 0) {
        this.loadTownship(0)
      }
    })
  }
  public emitData() {
    this.$emit('update:cityId', this.cityId)
    this.$emit('update:countyId', this.countyId)
    this.$emit('update:townshipId', this.townshipId)
  }

  public cityChange() {
    this.loadCounty(1)
    this.emitData()
  }
  public countyChange() {
    this.loadTownship(1)
    this.emitData()
  }
  public loadCounty(reset: number) {
    if (reset === 1) {
      this.countyId = 0
    }
    this.countyList = [this.defItem]
    if (this.cityId > 0) {
      this.countyList = getSubDDL(this.cityList, this.cityId, this.firstType)
    }
  }
  public loadTownship(reset: number) {
    if (reset === 1) {
      this.townshipId = 0
    }
    this.townshipList = [this.defItem]
    if (this.countyId > 0) {
      this.townshipList = getSubDDL(this.countyList, this.countyId, this.firstType)
    }
  }

  public $refs!: {
  }
}
